module.exports = __webpack_public_path__ + "img/tabs.57b2d914.png";